(function () {
  'use strict';

  var Core = window.SiokiuuGeneratorSizeCore;
  if (!Core) return;

  var scenarioCopy = {
    home: {
      intro: 'Choose only the home essentials you expect to power during the same period.',
      assumption: 'Use the microwave, kettle, heater, air fryer, washer, dishwasher, or window A/C one at a time whenever possible.'
    },
    rv: {
      intro: 'Build your RV load from the appliances you actually use. Direct TT-30R needs can be included in the recommendation.',
      assumption: 'Turn off the RV A/C before using the microwave, kettle, grill, cooktop, water heater, or hair dryer.'
    },
    jobsite: {
      intro: 'Tool motors can require significantly more power during startup. SIOKIUU only recommends a model when light-duty 120V tools pass conservative running and startup headroom checks.',
      assumption: 'Use one motor-driven tool at a time whenever possible. Always check the tool nameplate, especially for saws, compressors, pressure washers, and welders.'
    }
  };

  var COMMON_APPLIANCE_IDS = {
    home: [
      'home-refrigerator-standard', 'home-freezer', 'home-led-lights', 'home-router', 'home-tv',
      'home-cpap-basic', 'home-furnace-blower', 'home-window-ac-5000', 'home-microwave', 'home-space-heater'
    ],
    rv: [
      'rv-ac-11000', 'rv-ac-13500', 'rv-ac-15000', 'rv-refrigerator', 'rv-converter',
      'rv-led-lights', 'rv-microwave', 'rv-coffee-maker', 'rv-tv', 'rv-device-charging'
    ],
    jobsite: [
      'job-led-lights', 'job-battery-chargers', 'job-drill-38', 'job-drill-12',
      'job-circular-saw', 'job-miter-saw', 'job-angle-grinder', 'job-compressor-half-hp'
    ]
  };

  var commonCopy = {
    home: {
      title: 'Common Home Essentials',
      description: 'Add the appliances you want to keep running during an outage.'
    },
    rv: {
      title: 'Common RV & Camping Appliances',
      description: 'Select your RV essentials, air conditioner, kitchen appliances, and electronics.'
    },
    jobsite: {
      title: 'Common Light-Duty Tools',
      description: 'For 120V tools. Confirm tool wattage before relying on a recommendation.'
    }
  };

  function formatWatts(value) {
    return Math.round(Number(value) || 0).toLocaleString('en-US') + 'W';
  }

  function escapeHtml(value) {
    var element = document.createElement('span');
    element.textContent = String(value == null ? '' : value);
    return element.innerHTML;
  }

  function numberValue(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) ? Math.round(number) : fallback;
  }

  function applianceIcon() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 20h10l-1-9H8l-1 9Z"/><path d="M9 11V8a3 3 0 0 1 6 0v3"/></svg>';
  }

  function removeIcon() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 7h14"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M8 7l1 13h6l1-13"/><path d="M9 7V4h6v3"/></svg>';
  }

  function purgeLegacyState() {
    [window.localStorage, window.sessionStorage].forEach(function (storage) {
      try {
        for (var index = storage.length - 1; index >= 0; index -= 1) {
          var key = storage.key(index);
          if (!key || key === 'siokiuu_power_selected_appliances' || !/(finder|generator|size)/i.test(key)) continue;
          var value = storage.getItem(key) || '';
          if (!/water[-_ ]?pump|sump[-_ ]?pump|well[-_ ]?pump|generic[-_ ]?(power[-_ ]?tools?|appliance)/i.test(value)) continue;
          try {
            var parsed = JSON.parse(value);
            var clean = function (entry) {
              if (Array.isArray(entry)) {
                return entry.map(clean).filter(function (item) { return item !== null; });
              }
              if (entry && typeof entry === 'object') {
                if (Core.isRemovedAppliance(entry)) return null;
                Object.keys(entry).forEach(function (property) {
                  var cleaned = clean(entry[property]);
                  if (cleaned === null) delete entry[property];
                  else entry[property] = cleaned;
                });
              }
              return entry;
            };
            storage.setItem(key, JSON.stringify(clean(parsed)));
          } catch (parseError) {
            storage.removeItem(key);
          }
        }
      } catch (error) {
      }
    });
  }

  function initFinder(root) {
    if (root.dataset.finderReady === 'true') return;
    root.dataset.finderReady = 'true';
    purgeLegacyState();

    var currentMode = 'home';
    var currentCategory = 'Popular';
    var staggeredUse = false;
    var jobsiteUseTogether = true;
    var compressorOffConfirmed = false;
    var needsTT30R = 'not-sure';
    var appliances = [];
    var editingIndex = -1;
    var lastLibraryTrigger = null;
    var commonExpanded = false;

    var body = root.querySelector('[data-finder-appliance-body]');
    var totalRunning = root.querySelector('[data-finder-total-running]');
    var totalStarting = root.querySelector('[data-finder-total-starting]');
    var resultRunning = root.querySelector('[data-finder-result-running]');
    var resultStarting = root.querySelector('[data-finder-result-starting]');
    var secondaryResult = root.querySelector('[data-finder-secondary-result]');
    var resultImage = root.querySelector('[data-finder-result-image]');
    var resultName = root.querySelector('[data-finder-result-name]');
    var resultSubtitle = root.querySelector('[data-finder-result-subtitle]');
    var resultPrice = root.querySelector('[data-finder-result-price]');
    var resultRunningSpec = root.querySelector('[data-finder-result-running-spec]');
    var resultStartingSpec = root.querySelector('[data-finder-result-starting-spec]');
    var resultDescription = root.querySelector('[data-finder-result-description]');
    var recommendationHeading = root.querySelector('[data-finder-recommendation-heading]');
    var recommendationLabel = root.querySelector('[data-finder-recommendation-label]');
    var recommendationProduct = root.querySelector('[data-finder-recommendation-product]');
    var emptyState = root.querySelector('[data-finder-empty-state]');
    var emptyActions = root.querySelector('[data-finder-empty-actions]');
    var resultCard = root.querySelector('[data-finder-result-card]');
    var resultUrl = root.querySelector('[data-finder-result-url]');
    var secondaryAction = root.querySelector('[data-finder-secondary-action]');
    var warning = root.querySelector('[data-finder-warning]');
    var staggerToggle = root.querySelector('[data-finder-stagger-toggle]');
    var staggerControl = root.querySelector('[data-finder-stagger-control]');
    var staggerNotice = root.querySelector('[data-finder-stagger-notice]');
    var rvControl = root.querySelector('[data-finder-rv-control]');
    var tt30rSelect = root.querySelector('[data-finder-tt30r]');
    var jobsiteControl = root.querySelector('[data-finder-jobsite-control]');
    var jobsiteAssumption = root.querySelector('[data-finder-jobsite-assumption]');
    var compressorConfirm = root.querySelector('[data-finder-compressor-confirm]');
    var compressorOff = root.querySelector('[data-finder-compressor-off]');
    var scenarioIntro = root.querySelector('[data-finder-scenario-intro]');
    var jobsiteDisclaimer = root.querySelector('[data-finder-jobsite-disclaimer]');
    var selectedCount = root.querySelector('[data-finder-selected-count]');
    var expertPanel = root.querySelector('[data-finder-expert]');
    var contactBody = root.querySelector('[data-finder-contact-body]');
    var contactSummary = root.querySelector('[data-finder-contact-summary]');
    var contactEmail = root.querySelector('[data-finder-contact-email]');
    var contactSuccess = root.querySelector('[data-finder-contact-success]');
    var contactForm = root.querySelector('.siokiuu-finder-contact-form');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-finder-tab]'));
    var scenarios = Array.prototype.slice.call(root.querySelectorAll('[data-finder-scenario]'));
    var resetButton = root.querySelector('[data-finder-reset]');
    var library = root.querySelector('[data-finder-library]');
    var libraryOpen = root.querySelector('[data-finder-library-open]');
    var librarySearch = root.querySelector('[data-finder-library-search]');
    var libraryCategories = root.querySelector('[data-finder-library-categories]');
    var libraryList = root.querySelector('[data-finder-library-list]');
    var commonTitle = root.querySelector('[data-finder-common-title]');
    var commonDescription = root.querySelector('[data-finder-common-description]');
    var commonGrid = root.querySelector('[data-finder-common-grid]');
    var commonMore = root.querySelector('[data-finder-common-more]');
    var commonMoreLabel = root.querySelector('[data-finder-common-more-label]');
    var disclaimerToggle = root.querySelector('[data-finder-disclaimer-toggle]');
    var disclaimerPanel = root.querySelector('[data-finder-disclaimer-panel]');
    var customOpen = root.querySelector('[data-finder-custom-open]');
    var customDirectOpen = root.querySelector('[data-finder-custom-direct-open]');
    var customForm = root.querySelector('[data-finder-custom-form]');
    var customTitle = root.querySelector('[data-finder-custom-title]');
    var customCancel = root.querySelector('[data-finder-custom-cancel]');
    var restoreDefaults = root.querySelector('[data-finder-restore-defaults]');
    var formError = root.querySelector('[data-finder-form-error]');
    var contactSubmitStorageKey = 'siokiuuFinderExpertFormSubmitted';

    var generators = Array.prototype.slice.call(root.querySelectorAll('[data-finder-generator]')).map(function (card) {
      var running = numberValue(card.dataset.running, 0);
      var starting = numberValue(card.dataset.starting, 0);
      return {
        id: card.dataset.id || '',
        modelId: card.dataset.modelId || card.dataset.id || '',
        name: card.dataset.name || '',
        subtitle: card.dataset.subtitle || '',
        publishedRunningWatts: running,
        publishedStartingWatts: starting,
        runningWatts: running,
        startingWatts: starting,
        price: card.dataset.price || '',
        url: card.dataset.url || '#',
        image: card.dataset.image || '',
        description: card.dataset.description || '',
        available: card.dataset.available !== 'false',
        parallelReady: card.dataset.parallelReady === 'true',
        parallelHasTT30R: card.dataset.parallelTt30r === 'true',
        parallelKitUrl: card.dataset.parallelKitUrl || '',
        order: numberValue(card.dataset.order, 0),
        isOpenFrame: card.dataset.openFrame === 'true',
        isInverter: card.dataset.openFrame !== 'true',
        hasTT30R: card.dataset.tt30r === 'true',
        voltage: 120
      };
    });

    function activeSelected() {
      return appliances.filter(function (item) { return item.quantity > 0; });
    }

    function activeLoadResult() {
      var loads = Core.calculateLoads(appliances);
      var active;
      if (currentMode === 'jobsite') {
        active = Core.calculateJobsiteLoad(appliances, {
          useTogether: jobsiteUseTogether,
          compressorOffConfirmed: compressorOffConfirmed
        });
      } else {
        active = staggeredUse ? loads.staggered : loads.allAtOnce;
      }
      return {
        loads: loads,
        active: active,
        hasConflict: currentMode === 'jobsite' ? Boolean(active.autoRestartConflict) : Core.hasStaggerConflict(appliances)
      };
    }

    function recommendationFor(result) {
      return Core.evaluateRecommendation(generators, appliances, result.active, currentMode, {
        needsTT30R: needsTT30R,
        useTogether: jobsiteUseTogether,
        compressorOffConfirmed: compressorOffConfirmed
      });
    }

    function scenarioAssumption() {
      if (currentMode === 'jobsite') {
        return jobsiteUseTogether
          ? 'This result assumes all selected tools may remain powered together. Motor startup demand can vary by tool condition and extension-cord length.'
          : 'This recommendation assumes one motor-driven tool is used at a time.';
      }
      return scenarioCopy[currentMode].assumption;
    }

    function buildContactPayload(result, recommendation) {
      var demand = recommendation.demand || { runTotal: 0, peakNeeded: 0 };
      var recommendedName = recommendation.generator
        ? (recommendation.unitCount === 2 ? '2 x ' + recommendation.generator.name : recommendation.generator.name)
        : recommendation.title;
      var lines = [
        'Generator Size Finder request',
        'Page: ' + window.location.href,
        'Scenario: ' + currentMode,
        'Calculation mode: ' + (currentMode === 'jobsite' ? (jobsiteUseTogether ? 'Selected motor tools together' : 'One motor-driven tool at a time') : (staggeredUse ? 'Staggered use' : 'All selected appliances together')),
        'Required load: ' + formatWatts(demand.runTotal) + ' running / ' + formatWatts(demand.peakNeeded) + ' starting',
        'Recommendation status: ' + recommendation.status,
        'Assumption: ' + scenarioAssumption(),
        recommendation.generator ? 'Recommended setup: ' + recommendedName : 'Recommendation: ' + recommendation.title,
        '',
        'Selected devices:'
      ];
      activeSelected().forEach(function (item) {
        lines.push('- ' + item.name + ' | Qty ' + item.quantity + ' | ' + formatWatts(item.runningWatts) + ' running / ' + formatWatts(item.startingWatts) + ' starting | ' + (item.wattageConfirmed ? 'Confirmed' : 'Estimated'));
      });
      return lines.join('\n');
    }

    function updateContactPayload(result, recommendation) {
      if (contactBody) contactBody.value = buildContactPayload(result, recommendation);
      if (contactSummary) {
        if (!recommendation.generator) contactSummary.textContent = recommendation.message;
        else if (recommendation.unitCount === 2) contactSummary.textContent = 'Want our team to double-check your parallel setup? Your current match is 2 x ' + recommendation.generator.name + '.';
        else contactSummary.textContent = 'Want our team to double-check your setup? Your current match is ' + recommendation.generator.name + '.';
      }
    }

    function commonAppliancesFor(mode) {
      return (COMMON_APPLIANCE_IDS[mode] || []).map(function (id) {
        var item = Core.findCatalogAppliance(mode, id);
        if (!item) console.warn('[SIOKIUU Find My Size] Missing common appliance:', mode, id);
        return item;
      }).filter(function (item) {
        return item && item.id && Number.isFinite(Number(item.runningWatts)) && Number(item.runningWatts) > 0;
      });
    }

    function validateApplianceLibrary() {
      var validModes = ['home', 'rv', 'jobsite'];
      var minimumCatalogCounts = { home: 20, rv: 20, jobsite: 15 };
      var minimumCommonCounts = { home: 10, rv: 10, jobsite: 8 };
      var seenIds = Object.create(null);
      var report = { valid: true, catalogs: {}, common: {}, warnings: [] };

      validModes.forEach(function (mode) {
        var catalog = Core.getScenarioCatalog(mode);
        var common = commonAppliancesFor(mode);
        report.catalogs[mode] = catalog.length;
        report.common[mode] = common.length;

        if (catalog.length < minimumCatalogCounts[mode]) report.warnings.push(mode + ' catalog has only ' + catalog.length + ' items.');
        if (common.length < minimumCommonCounts[mode]) report.warnings.push(mode + ' common list has only ' + common.length + ' items.');

        catalog.forEach(function (item) {
          if (!item || !item.id) {
            report.warnings.push(mode + ' contains an appliance without an id.');
            return;
          }
          if (seenIds[item.id]) report.warnings.push('Duplicate appliance id: ' + item.id + '.');
          seenIds[item.id] = true;
          if (item.scenario !== mode) report.warnings.push(item.id + ' has scenario "' + item.scenario + '" instead of "' + mode + '".');
          var isNameplateReference = item.requiresNameplate && item.autoRecommendationEligible === false;
          var runningWattsValid = Number.isFinite(Number(item.runningWatts)) && (Number(item.runningWatts) > 0 || (isNameplateReference && Number(item.runningWatts) === 0));
          if (!runningWattsValid) report.warnings.push(item.id + ' has invalid running watts.');
          if (!Number.isFinite(Number(item.startingWatts)) || Number(item.startingWatts) < Number(item.runningWatts)) report.warnings.push(item.id + ' has invalid starting watts.');
        });
      });

      report.valid = report.warnings.length === 0;
      report.warnings.forEach(function (warningMessage) { console.warn('[SIOKIUU Find My Size]', warningMessage); });
      return report;
    }

    function renderCommonAppliances() {
      if (!commonGrid) return;
      var copy = commonCopy[currentMode] || commonCopy.home;
      var commonItems = commonAppliancesFor(currentMode);
      if (commonTitle) commonTitle.textContent = copy.title;
      if (commonDescription) commonDescription.textContent = copy.description;
      commonGrid.dataset.commonCount = String(commonItems.length);
      commonGrid.classList.toggle('is-expanded', commonExpanded);
      if (commonMore) {
        commonMore.hidden = commonItems.length <= 4;
        commonMore.setAttribute('aria-expanded', String(commonExpanded));
      }
      if (commonMoreLabel) commonMoreLabel.textContent = commonExpanded ? 'Show Less' : 'More';
      commonGrid.innerHTML = commonItems.map(function (item) {
        var selected = appliances.find(function (appliance) { return appliance.id === item.id; });
        var selectedQuantity = selected ? selected.quantity : 0;
        var startingWatts = Number(item.startingWatts) >= Number(item.runningWatts) ? item.startingWatts : item.runningWatts;
        var loadLabel = Core.loadLabel(item);
        var loadLabelClass = !item.autoRecommendationEligible
          ? 'is-reference'
          : item.requiresNameplate
            ? 'is-nameplate'
            : item.loadType === 'motor'
              ? 'is-surge'
              : item.loadType === 'electronic'
                ? 'is-sensitive'
                : 'is-steady';
        var mainAction = selected
          ? 'data-finder-common-focus="' + escapeHtml(item.id) + '" aria-label="Edit ' + escapeHtml(item.name) + ' in your selection"'
          : 'data-finder-common-add="' + escapeHtml(item.id) + '" aria-label="Add ' + escapeHtml(item.name) + '"';
        var footer = selected
          ? '<span class="siokiuu-finder-common-card__added">Added</span><span class="siokiuu-finder-common-card__qty"><button type="button" data-finder-common-qty="minus" data-appliance-id="' + escapeHtml(item.id) + '" aria-label="Decrease ' + escapeHtml(item.name) + ' quantity">&minus;</button><output>' + selectedQuantity + '</output><button type="button" data-finder-common-qty="plus" data-appliance-id="' + escapeHtml(item.id) + '" aria-label="Increase ' + escapeHtml(item.name) + ' quantity">+</button></span>'
          : '<button class="siokiuu-finder-common-card__add" type="button" data-finder-common-add="' + escapeHtml(item.id) + '"><span aria-hidden="true">+</span> Add</button>';
        return [
          '<article class="siokiuu-finder-common-card' + (selected ? ' is-selected' : '') + '" role="listitem">',
          '<button class="siokiuu-finder-common-card__main" type="button" ' + mainAction + '>',
          '<span class="siokiuu-finder-common-card__icon">' + applianceIcon() + '</span>',
          '<strong>' + escapeHtml(item.name) + '</strong>',
          '<span class="siokiuu-finder-common-card__watts"><span><small>Running</small>' + formatWatts(item.runningWatts) + '</span><span><small>Starting</small>' + formatWatts(startingWatts) + '</span></span>',
          '<small class="siokiuu-finder-common-card__label ' + loadLabelClass + '">' + escapeHtml(loadLabel) + '</small>',
          '</button>',
          '<div class="siokiuu-finder-common-card__footer">' + footer + '</div>',
          '</article>'
        ].join('');
      }).join('');
    }

    function renderRows() {
      if (!body) return;
      if (!appliances.length) {
        body.innerHTML = '<tr class="siokiuu-finder-table__empty siokiuu-finder-empty-row"><td colspan="7"><strong>No appliances selected yet.</strong><span>Choose from the common appliances above or browse the full appliance library.</span></td></tr>';
        return;
      }
      body.innerHTML = appliances.map(function (item, index) {
        var metrics = Core.rowMetrics(item);
        var badge = item.requiresNameplate
          ? '<small class="siokiuu-finder-row-badge siokiuu-finder-device-badge ' + (item.wattageConfirmed ? 'is-confirmed' : '') + '">' + (item.wattageConfirmed ? 'Wattage confirmed' : 'Check Nameplate') + '</small>'
          : '<small class="siokiuu-finder-row-badge siokiuu-finder-device-badge">' + escapeHtml(Core.loadLabel(item)) + '</small>';
        return [
          '<tr data-finder-row="' + index + '">',
          '<td data-label="Device"><span class="siokiuu-finder-appliance-name siokiuu-finder-device-name">' + applianceIcon() + '<span>' + escapeHtml(item.name) + badge + '</span></span></td>',
          '<td data-label="Running Watts">' + formatWatts(item.runningWatts) + '</td>',
          '<td data-label="Starting Watts">' + formatWatts(item.startingWatts) + '</td>',
          '<td data-label="Quantity"><span class="siokiuu-finder-qty"><button type="button" data-finder-qty="minus" aria-label="Decrease ' + escapeHtml(item.name) + ' quantity">-</button><output>' + item.quantity + '</output><button type="button" data-finder-qty="plus" aria-label="Increase ' + escapeHtml(item.name) + ' quantity">+</button></span></td>',
          '<td data-label="Running Total">' + formatWatts(metrics.rowRunningWatts) + '</td>',
          '<td data-label="Starting Total">' + formatWatts(metrics.rowStartingTotal) + '</td>',
          '<td data-label="Actions"><span class="siokiuu-finder-row-actions siokiuu-finder-device-actions"><button type="button" data-finder-edit>' + (item.requiresNameplate ? 'Confirm / Edit Wattage' : 'Edit Wattage') + '</button><button class="siokiuu-finder-remove" type="button" data-finder-remove aria-label="Remove ' + escapeHtml(item.name) + '">' + removeIcon() + '</button></span></td>',
          '</tr>'
        ].join('');
      }).join('');
    }

    function updateProduct(product, recommendation) {
      var displayName = recommendation.unitCount === 2 ? '2 \u00d7 ' + product.name : product.name;
      if (resultImage && product.image) resultImage.src = product.image;
      if (resultImage) resultImage.alt = product.name + ' ' + product.subtitle;
      if (resultName) resultName.textContent = displayName;
      if (resultSubtitle) resultSubtitle.textContent = product.subtitle;
      if (resultPrice) {
        resultPrice.textContent = product.price || '';
        resultPrice.hidden = !product.price;
      }
      if (resultRunningSpec) resultRunningSpec.textContent = formatWatts(product.runningWatts) + ' Running';
      if (resultStartingSpec) resultStartingSpec.textContent = formatWatts(product.startingWatts) + ' Starting';
      if (resultDescription) {
        resultDescription.textContent = recommendation.message;
        resultDescription.hidden = false;
      }
      if (resultCard) {
        resultCard.href = product.url;
        resultCard.setAttribute('aria-label', 'View ' + product.name);
      }
      if (resultUrl) {
        var kitUrl = recommendation.unitCount === 2 ? product.parallelKitUrl : '';
        resultUrl.href = kitUrl || product.url;
        resultUrl.textContent = kitUrl ? 'See the Parallel Kit' : 'View This Model';
        resultUrl.hidden = false;
      }
      if (secondaryAction) {
        if (recommendation.unitCount === 2 && product.parallelKitUrl) {
          secondaryAction.href = product.url;
          secondaryAction.textContent = 'View This Model';
        } else if (recommendation.unitCount === 2) {
          secondaryAction.href = '/pages/compare-models';
          secondaryAction.textContent = 'Compare Models';
        } else {
          secondaryAction.href = '/collections/generators';
          secondaryAction.textContent = 'View All Models';
        }
      }
    }

    function updateRecommendation(result, recommendation) {
      var product = recommendation.generator;
      if (recommendationHeading) recommendationHeading.textContent = recommendation.title;
      if (recommendationLabel) {
        recommendationLabel.textContent = recommendation.label || '';
        recommendationLabel.hidden = !recommendation.label;
      }
      if (warning) warning.hidden = true;
      if (expertPanel) expertPanel.hidden = true;

      if (product) {
        root.classList.remove('is-over-limit');
        if (emptyState) emptyState.hidden = true;
        if (recommendationProduct) recommendationProduct.hidden = false;
        if (emptyActions) emptyActions.hidden = true;
        updateProduct(product, recommendation);
        return;
      }

      root.classList.toggle('is-over-limit', recommendation.status !== 'EMPTY');
      if (recommendationProduct) recommendationProduct.hidden = true;
      if (resultDescription) resultDescription.hidden = true;
      if (resultUrl) resultUrl.hidden = true;
      if (secondaryAction) {
        secondaryAction.href = '/collections/generators';
        secondaryAction.textContent = 'View All Models';
      }
      if (emptyState) {
        emptyState.hidden = false;
        var title = emptyState.querySelector('strong');
        var copy = emptyState.querySelector('p');
        var note = emptyState.querySelector('small');
        if (title) title.textContent = recommendation.title;
        if (copy) copy.textContent = recommendation.message;
        if (note) note.textContent = recommendation.status === 'EMPTY'
          ? 'Add only the appliances you expect to use during the same period. You can edit any wattage using the values shown on the appliance label.'
          : 'Review the selected devices, confirm label wattages, or contact SIOKIUU Support for help.';
      }
      if (emptyActions) emptyActions.hidden = recommendation.status === 'EMPTY';
    }

    function updateControls(result) {
      var isJobsite = currentMode === 'jobsite';
      if (staggerControl) staggerControl.hidden = isJobsite;
      if (rvControl) rvControl.hidden = currentMode !== 'rv';
      if (jobsiteControl) jobsiteControl.hidden = !isJobsite;
      if (jobsiteDisclaimer) jobsiteDisclaimer.hidden = !isJobsite;
      if (scenarioIntro) scenarioIntro.textContent = scenarioCopy[currentMode].intro;
      if (jobsiteAssumption) jobsiteAssumption.textContent = scenarioAssumption();

      var selected = activeSelected();
      var compressorPresent = selected.some(function (item) { return /compressor/.test(item.id); });
      var anotherMotor = selected.some(function (item) { return item.loadType === 'motor' && !/compressor/.test(item.id); });
      if (compressorConfirm) compressorConfirm.hidden = !(isJobsite && compressorPresent && anotherMotor && !jobsiteUseTogether);
      if (selectedCount) selectedCount.textContent = selected.length + (selected.length === 1 ? ' selected' : ' selected');
      if (staggerControl) staggerControl.classList.toggle('is-emphasized', result.hasConflict);
    }

    function updateResults() {
      var result = activeLoadResult();
      var recommendation = recommendationFor(result);
      var demand = recommendation.demand || Core.calculateDemand(appliances);
      if (totalRunning) totalRunning.textContent = formatWatts(demand.runTotal);
      if (totalStarting) totalStarting.textContent = formatWatts(demand.peakNeeded);
      if (resultRunning) resultRunning.textContent = formatWatts(demand.runTotal);
      if (resultStarting) resultStarting.textContent = formatWatts(demand.peakNeeded);
      if (secondaryResult) {
        if (!appliances.length) secondaryResult.textContent = 'Select appliances to begin.';
        else if (recommendation.status && recommendation.status.indexOf('A_') === 0) secondaryResult.textContent = 'Selected load: ' + formatWatts(recommendation.demand.runTotal) + ' running / ' + formatWatts(recommendation.demand.peakNeeded) + ' starting.';
        else if (currentMode === 'jobsite') secondaryResult.textContent = scenarioAssumption();
        else secondaryResult.textContent = (staggeredUse ? 'All at once: ' : 'Staggered use: ') + formatWatts(staggeredUse ? result.loads.allAtOnce.runningWatts : result.loads.staggered.runningWatts) + ' running / ' + formatWatts(staggeredUse ? result.loads.allAtOnce.startingWatts : result.loads.staggered.startingWatts) + ' starting';
      }
      if (staggerNotice) {
        staggerNotice.hidden = !result.hasConflict;
        staggerNotice.textContent = currentMode === 'jobsite' && result.active.autoRestartConflict
          ? 'The compressor may restart automatically while another motor-driven tool is operating.'
          : scenarioCopy[currentMode].assumption;
      }
      updateControls(result);
      updateRecommendation(result, recommendation);
      updateContactPayload(result, recommendation);
    }

    function renderCatalog() {
      if (!libraryCategories || !libraryList) return;
      var categoryNames = Core.getScenarioCategories(currentMode);
      libraryCategories.innerHTML = categoryNames.map(function (category) {
        return '<button type="button" class="' + (category === currentCategory ? 'is-active' : '') + '" aria-pressed="' + (category === currentCategory ? 'true' : 'false') + '" data-finder-category="' + escapeHtml(category) + '">' + escapeHtml(category) + '</button>';
      }).join('');
      var query = librarySearch ? librarySearch.value : '';
      var matches = Core.searchCatalog(currentMode, query, query ? 'All' : currentCategory);
      if (!matches.length) {
        libraryList.innerHTML = '<p class="siokiuu-finder-library__empty">No matching devices in this scenario. Try another search or add a custom device.</p>';
        return;
      }
      libraryList.innerHTML = matches.map(function (item) {
        var selected = appliances.find(function (appliance) { return appliance.id === item.id; });
        return [
          '<article class="siokiuu-finder-library-card">',
          '<div class="siokiuu-finder-library-card__copy"><strong>' + escapeHtml(item.name) + '</strong><span>' + formatWatts(item.runningWatts) + ' Running &middot; ' + formatWatts(item.startingWatts) + ' Starting</span><small>' + escapeHtml(Core.loadLabel(item)) + '</small></div>',
          '<button type="button" data-finder-catalog-add="' + escapeHtml(item.id) + '">' + (selected ? 'Add another (' + selected.quantity + ')' : 'Add') + '</button>',
          '</article>'
        ].join('');
      }).join('');
    }

    function render() {
      appliances = Core.sanitizeAppliances(appliances);
      renderCommonAppliances();
      renderRows();
      renderCatalog();
      updateResults();
    }

    function resetCustomForm() {
      editingIndex = -1;
      if (!customForm) return;
      customForm.reset();
      customForm.hidden = true;
      if (customTitle) customTitle.textContent = 'Custom device';
      if (restoreDefaults) restoreDefaults.hidden = true;
      if (formError) {
        formError.hidden = true;
        formError.textContent = '';
      }
    }

    function openLibrary(trigger) {
      if (!library) return;
      lastLibraryTrigger = trigger || document.activeElement;
      library.hidden = false;
      document.body.classList.add('siokiuu-finder-library-open');
      renderCatalog();
      window.setTimeout(function () { if (librarySearch) librarySearch.focus(); }, 0);
    }

    function closeLibrary() {
      if (!library) return;
      library.hidden = true;
      document.body.classList.remove('siokiuu-finder-library-open');
      resetCustomForm();
      if (lastLibraryTrigger && lastLibraryTrigger.focus) lastLibraryTrigger.focus();
    }

    function openEditor(index) {
      if (!customForm || !appliances[index]) return;
      editingIndex = index;
      var item = appliances[index];
      openLibrary();
      customForm.hidden = false;
      customForm.elements.name.value = item.name;
      customForm.elements.running.value = item.runningWatts;
      customForm.elements.starting.value = item.startingWatts;
      customForm.elements.quantity.value = item.quantity;
      if (customTitle) customTitle.textContent = item.requiresNameplate ? 'Confirm / Edit Wattage' : 'Edit device wattage';
      if (restoreDefaults) restoreDefaults.hidden = item.isCustom;
      customForm.elements.running.focus();
    }

    function addCatalogItem(id) {
      var existing = appliances.find(function (item) { return item.id === id; });
      if (existing) existing.quantity = Math.min(Core.MAX_QUANTITY, existing.quantity + 1);
      else {
        var item = Core.findCatalogAppliance(currentMode, id);
        if (!item) return;
        item.quantity = 1;
        item.wattageConfirmed = false;
        appliances.push(item);
      }
      render();
    }

    function setMode(mode) {
      currentMode = mode;
      currentCategory = 'Popular';
      staggeredUse = false;
      jobsiteUseTogether = true;
      compressorOffConfirmed = false;
      needsTT30R = 'not-sure';
      appliances = [];
      commonExpanded = false;
      if (staggerToggle) staggerToggle.checked = false;
      if (tt30rSelect) tt30rSelect.value = 'not-sure';
      if (compressorOff) compressorOff.checked = false;
      root.querySelectorAll('input[name="finder-jobsite-mode"]').forEach(function (radio) { radio.checked = radio.value === 'together'; });
      tabs.forEach(function (tab) {
        var active = tab.dataset.finderTab === currentMode;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
      });
      scenarios.forEach(function (scenario) {
        scenario.classList.toggle('is-active', scenario.dataset.finderScenario === currentMode);
      });
      if (librarySearch) librarySearch.value = '';
      render();
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var nextMode = tab.dataset.finderTab || 'home';
        if (nextMode === currentMode) return;
        if (appliances.length && !window.confirm('Switching scenarios will clear your current appliance selection. Continue?')) return;
        setMode(nextMode);
      });
    });
    if (staggerToggle) staggerToggle.addEventListener('change', function () { staggeredUse = staggerToggle.checked; render(); });
    if (tt30rSelect) tt30rSelect.addEventListener('change', function () { needsTT30R = tt30rSelect.value; render(); });
    root.querySelectorAll('input[name="finder-jobsite-mode"]').forEach(function (radio) {
      radio.addEventListener('change', function () { jobsiteUseTogether = radio.value === 'together'; render(); });
    });
    if (compressorOff) compressorOff.addEventListener('change', function () { compressorOffConfirmed = compressorOff.checked; render(); });

    if (body) {
      body.addEventListener('click', function (event) {
        var button = event.target.closest('button');
        var row = event.target.closest('[data-finder-row]');
        if (!button || !row) return;
        var index = numberValue(row.dataset.finderRow, -1);
        if (index < 0 || !appliances[index]) return;
        if (button.hasAttribute('data-finder-remove')) appliances.splice(index, 1);
        else if (button.hasAttribute('data-finder-edit')) {
          openEditor(index);
          return;
        } else if (button.dataset.finderQty === 'minus') {
          appliances[index].quantity -= 1;
          if (appliances[index].quantity <= 0) appliances.splice(index, 1);
        } else if (button.dataset.finderQty === 'plus') {
          appliances[index].quantity = Math.min(Core.MAX_QUANTITY, appliances[index].quantity + 1);
        }
        render();
      });
    }

    if (commonGrid) {
      commonGrid.addEventListener('click', function (event) {
        var quantityButton = event.target.closest('[data-finder-common-qty]');
        if (quantityButton) {
          var quantityId = quantityButton.dataset.applianceId;
          var quantityItem = appliances.find(function (item) { return item.id === quantityId; });
          if (!quantityItem) return;
          if (quantityButton.dataset.finderCommonQty === 'minus') quantityItem.quantity -= 1;
          else quantityItem.quantity = Math.min(Core.MAX_QUANTITY, quantityItem.quantity + 1);
          if (quantityItem.quantity <= 0) appliances = appliances.filter(function (item) { return item.id !== quantityId; });
          render();
          return;
        }

        var addButton = event.target.closest('[data-finder-common-add]');
        if (addButton) {
          addCatalogItem(addButton.dataset.finderCommonAdd);
          return;
        }

        var focusButton = event.target.closest('[data-finder-common-focus]');
        if (focusButton) {
          var selectedIndex = appliances.findIndex(function (item) { return item.id === focusButton.dataset.finderCommonFocus; });
          var selectedRow = selectedIndex >= 0 ? body.querySelector('[data-finder-row="' + selectedIndex + '"]') : null;
          if (selectedRow) selectedRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }
    if (commonMore) commonMore.addEventListener('click', function () {
      commonExpanded = !commonExpanded;
      renderCommonAppliances();
    });
    if (disclaimerToggle && disclaimerPanel) disclaimerToggle.addEventListener('click', function () {
      var expanded = disclaimerToggle.getAttribute('aria-expanded') === 'true';
      disclaimerToggle.setAttribute('aria-expanded', String(!expanded));
      disclaimerPanel.classList.toggle('is-expanded', !expanded);
      var icon = disclaimerToggle.querySelector('.siokiuu-finder-disclaimer-toggle__icon');
      if (icon) icon.textContent = expanded ? '+' : '\u2212';
    });

    if (libraryOpen) libraryOpen.addEventListener('click', function () { openLibrary(libraryOpen); });
    root.querySelectorAll('[data-finder-library-close]').forEach(function (button) { button.addEventListener('click', closeLibrary); });
    if (librarySearch) librarySearch.addEventListener('input', renderCatalog);
    if (libraryCategories) libraryCategories.addEventListener('click', function (event) {
      var button = event.target.closest('[data-finder-category]');
      if (!button) return;
      currentCategory = button.dataset.finderCategory;
      if (librarySearch) librarySearch.value = '';
      renderCatalog();
    });
    if (libraryList) libraryList.addEventListener('click', function (event) {
      var button = event.target.closest('[data-finder-catalog-add]');
      if (button) addCatalogItem(button.dataset.finderCatalogAdd);
    });
    if (customOpen && customForm) customOpen.addEventListener('click', function () {
      resetCustomForm();
      customForm.hidden = false;
      if (customForm.elements.name) customForm.elements.name.focus();
    });
    if (customDirectOpen && customForm) customDirectOpen.addEventListener('click', function () {
      openLibrary(customDirectOpen);
      resetCustomForm();
      customForm.hidden = false;
      window.setTimeout(function () { if (customForm.elements.name) customForm.elements.name.focus(); }, 0);
    });
    if (customCancel) customCancel.addEventListener('click', resetCustomForm);
    if (restoreDefaults) restoreDefaults.addEventListener('click', function () {
      if (editingIndex < 0 || !appliances[editingIndex]) return;
      var catalog = Core.findCatalogAppliance(currentMode, appliances[editingIndex].id);
      if (!catalog) return;
      customForm.elements.running.value = catalog.runningWatts;
      customForm.elements.starting.value = catalog.startingWatts;
    });

    if (customForm) customForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var draft = {
        name: String(customForm.elements.name.value || '').trim(),
        runningWatts: Number(customForm.elements.running.value),
        startingWatts: Number(customForm.elements.starting.value)
      };
      var validation = Core.validateCustomAppliance(draft);
      if (!validation.valid) {
        if (formError) {
          formError.textContent = validation.errors.join(' ');
          formError.hidden = false;
          formError.focus && formError.focus();
        }
        return;
      }
      var quantity = Math.min(Core.MAX_QUANTITY, Math.max(1, numberValue(customForm.elements.quantity.value, 1)));
      if (editingIndex >= 0 && appliances[editingIndex]) {
        appliances[editingIndex].name = draft.name;
        appliances[editingIndex].runningWatts = draft.runningWatts;
        appliances[editingIndex].startingWatts = draft.startingWatts;
        appliances[editingIndex].quantity = quantity;
        appliances[editingIndex].wattageConfirmed = true;
      } else {
        appliances.push({
          id: 'custom-' + Date.now(), scenario: currentMode, category: 'Custom', name: draft.name,
          runningWatts: draft.runningWatts, startingWatts: draft.startingWatts, quantity: quantity,
          loadType: 'electronic', voltage: 120, popular: false, userControlled: true,
          autoRestart: false, staggerGroup: null, requiresNameplate: false,
          wattageConfirmed: true, autoRecommendationEligible: true, isCustom: true
        });
      }
      resetCustomForm();
      render();
    });

    if (resetButton) resetButton.addEventListener('click', function () {
      appliances = [];
      staggeredUse = false;
      jobsiteUseTogether = true;
      compressorOffConfirmed = false;
      if (staggerToggle) staggerToggle.checked = false;
      if (compressorOff) compressorOff.checked = false;
      render();
    });
    if (root.querySelector('[data-finder-empty-edit]')) root.querySelector('[data-finder-empty-edit]').addEventListener('click', function () {
      var index = appliances.findIndex(function (item) { return item.requiresNameplate && !item.wattageConfirmed; });
      if (index < 0 && appliances.length) index = 0;
      if (index >= 0) openEditor(index);
    });
    if (root.querySelector('[data-finder-empty-remove]')) root.querySelector('[data-finder-empty-remove]').addEventListener('click', function () {
      if (!appliances.length) return;
      var index = appliances.reduce(function (largest, item, itemIndex) {
        return item.startingWatts > appliances[largest].startingWatts ? itemIndex : largest;
      }, 0);
      appliances.splice(index, 1);
      render();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && library && !library.hidden) closeLibrary();
    });

    function validateContactEmail(showMessage) {
      if (!contactEmail) return true;
      var value = String(contactEmail.value || '').trim();
      contactEmail.setCustomValidity('');
      if (!value) contactEmail.setCustomValidity('Please enter your email address.');
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) contactEmail.setCustomValidity('Please enter a valid email address, such as name@example.com.');
      if (!contactEmail.validationMessage) return true;
      if (showMessage && contactEmail.reportValidity) contactEmail.reportValidity();
      return false;
    }

    if (contactForm) contactForm.addEventListener('submit', function (event) {
      if (!validateContactEmail(true)) {
        event.preventDefault();
        return;
      }
      try { sessionStorage.setItem(contactSubmitStorageKey, 'true'); } catch (error) {}
      var result = activeLoadResult();
      updateContactPayload(result, recommendationFor(result));
    });
    if (contactEmail) {
      contactEmail.addEventListener('invalid', function () { validateContactEmail(false); });
      contactEmail.addEventListener('input', function () { validateContactEmail(false); });
    }
    var hasPostedSuccess = false;
    try { hasPostedSuccess = sessionStorage.getItem(contactSubmitStorageKey) === 'true'; } catch (error) {}
    if (contactSuccess) {
      contactSuccess.hidden = !(contactSuccess.dataset.finderPostedSuccess === 'true' && hasPostedSuccess);
      if (!contactSuccess.hidden) {
        if (expertPanel) expertPanel.hidden = false;
        try { sessionStorage.removeItem(contactSubmitStorageKey); } catch (error) {}
      }
    }


    function restorePlannerSelections() {
      var powerData = window.SIOKIUU_POWER_DATA;
      if (!powerData) return;
      var payload;
      try {
        payload = JSON.parse(localStorage.getItem(powerData.storageKey) || 'null');
      } catch (error) {
        return;
      }
      if (!payload || payload.version !== powerData.version || !Array.isArray(payload.appliances) || numberValue(payload.expiresAt, 0) < Date.now()) {
        try { localStorage.removeItem(powerData.storageKey); } catch (error) {}
        return;
      }
      payload.appliances.slice(0, 30).forEach(function (item, index) {
        var runningWatts = numberValue(item.runningWatts, NaN);
        var startingWatts = numberValue(item.startingWatts, NaN);
        var quantity = Math.max(1, Math.min(Core.MAX_QUANTITY, numberValue(item.quantity, 1)));
        var name = String(item.name || '').trim().slice(0, 80);
        if (!name || !Number.isFinite(runningWatts) || runningWatts <= 0 || !Number.isFinite(startingWatts) || startingWatts < runningWatts) return;
        appliances.push({
          id: 'planner-transfer-' + String(item.id || index),
          scenario: 'home',
          category: 'Planner selection',
          name: name,
          runningWatts: runningWatts,
          startingWatts: startingWatts,
          quantity: quantity,
          loadType: 'electronic',
          voltage: 120,
          popular: false,
          userControlled: true,
          autoRestart: false,
          staggerGroup: null,
          requiresNameplate: false,
          wattageConfirmed: true,
          autoRecommendationEligible: true,
          isCustom: true
        });
      });
      try { localStorage.removeItem(powerData.storageKey); } catch (error) {}
    }

    restorePlannerSelections();

    var libraryValidation = validateApplianceLibrary();
    root.dataset.finderLibraryValid = String(libraryValidation.valid);
    root.dataset.finderCatalogCounts = ['home', 'rv', 'jobsite'].map(function (mode) { return mode + ':' + libraryValidation.catalogs[mode]; }).join(',');
    window.validateApplianceLibrary = validateApplianceLibrary;
    render();
  }

  function init() {
    document.querySelectorAll('[data-siokiuu-finder]').forEach(initFinder);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
